import { Description, Heading, Panel, PlusIcon, Spinner } from '@repo/ui'
import { useHistory } from 'react-router-dom'

import { Button } from '@/components/Button'
import { CardGridCategory } from '@/components/CardGridCategory'
import { PlaylistCard } from '@/components/PlaylistCard'
import { useQueryUserTriviaLists } from '@/pages/trivia-lists/queries/useQueryUserTriviaLists'
import StoreService from '@/store/StoreService'

import { validateTriviaList } from '../edit-trivia-list/utils/validate-list'

interface UserTriviaListsProps {
  onClick: (listId: string) => void
}

export function UserTriviaLists({ onClick }: UserTriviaListsProps) {
  const { user } = StoreService.getStore()
  const history = useHistory()

  const { data = [], isError, isLoading } = useQueryUserTriviaLists()

  if (isLoading) return <Spinner label='Loading your custom trivia lists...' />

  if (isError) {
    return (
      <Panel className='flex flex-col gap-6'>
        <div className='flex flex-col gap-2'>
          <Heading>Sorry, something went wrong</Heading>
          <Description>There was an error loading your custom trivia lists.</Description>
        </div>
        <Button text='Try Again' onClick={() => window.location.reload()} />
      </Panel>
    )
  }

  const validatedTriviaLists = data.map(validateTriviaList)
  const validLists = validatedTriviaLists.filter(list => list.validation.isValid)

  return (
    <CardGridCategory
      createCard={
        <>
          {user.canEditPlaylists && (
            <PlaylistCard
              className='border-4 border-dashed border-purple-500'
              icon={<PlusIcon />}
              title='Create a Custom Trivia List'
              onClick={() => {
                history.push(`/trivia/lists/create`)
              }}
            />
          )}
        </>
      }
      description={
        <Description>Trivia lists you{`'`}ve created and fine-tuned to perfection.</Description>
      }
      handleClick={onClick}
      heading='Your Custom Trivia Lists'
      headingAction={
        <>
          {user.canEditPlaylists && (
            <Button className='min-w-fit' text='Edit' to='/trivia/lists' variant='anchor' />
          )}
        </>
      }
      items={validLists}
    />
  )
}
